<template>
<div>
 

    <vue-form  v-if="!esqueceusenha" @submit.prevent="login" name="loginform" v-model="clientInfo" class=''>

        <div v-if="this.error" class='alert alert-danger'>
            {{ this.error }}
        </div>

        <div class="row">
            <vue-field class='col-12' type="string" ref="cpf" name="cpf" label="CPF" required :validations="['cpf']"></vue-field>
            <vue-field  class='col-12 ' type="password" name="password" label="Senha" required ></vue-field>
            
            <div class="col-12">
                 <input  class='btn btn-primary' type="submit" value="Entrar">
            </div>
        </div>
    </vue-form>
    
    <div class='mt4'>
        <a class='pointer' v-if="!esqueceusenha" @click="esqueceusenha = !esqueceusenha"> Esqueceu seu Senha? </a>


          <vue-form  v-if="esqueceusenha" @submit.prevent="submitEsqueceuSenha" name="esqueceusenha"   v-model="clientInfo" class='mt4 mb3'>

                <div v-if="this.error" class='alert alert-danger'>
                    {{ this.error }}
                </div>
                <div v-if="this.msg" class='alert alert-success'>
                    {{ this.msg }}
                </div>

                <div class="row">
                    <vue-field class='col-12' type="string" ref="cpfsenha" name="cpf" v-model="cpfesqueceusenha" label="Digite seu CPF para recuperar a senha" required :validations="['cpf']"></vue-field>
                    <div class="col-12">
                        <input  class='btn btn-primary' type="submit" value="Recuperar Senha">
                    </div>
                </div>

            </vue-form>

            <a class='pointer mt3' v-if="esqueceusenha" @click="esqueceusenha = !esqueceusenha"> Fazer Login </a>


    </div>

</div>
</template>

<script>

import validadeFormMixins from "@/mixins/validateForms"
import api from "@/api"

export default {

    mixins:[validadeFormMixins],
    data(){
        return{
            clientInfo:{},
            error:false,
            erromsg:'',
            msg:false,
            esqueceusenha:false,
        }
    },

    watch:{
        esqueceusenha:function(){
            this.msg="";
        }
      
    },

    computed:{
        user:function(){
            return this.$store.getters.user
        }
    },

    methods:{

        submitEsqueceuSenha:async function(){

            this.error = false;
            this.msg = false;
            var formValid = await this.validateForms();
            // if(!formValid) return
            let response = await this.$store.dispatch('recoverpassword', { cpf:this.clientInfo.cpf } ) 
            if(response.error){
                    this.error = "Dados inválidos" //response.data.error.message;
                    return false;
            }else{
                this.error = false;
                this.msg ="Um email foi enviado para "+response.email
                this.clientInfo.cpf=""
                return true;
            }

        },



        login:async function(){
            this.$emit('loginStart', {cpf:this.clientInfo.cpf} )
            this.error = false;
            this.msg = false;
            var formValid = await this.validateForms();
            // if(!formValid) return
            let response = await this.$store.dispatch('login', { cpf:this.clientInfo.cpf, password:this.clientInfo.password } ) 
            if(response.error){
                    this.error = "Dados inválidos" //response.data.error.message;
                    return false;
            }else{
                this.error = false;
                this.$emit('logged',this.user)
                return true;
            }
        },

        formsOk: async function(){

            let response;

            if(this.user && this.edit == false){
                //update user
                return true
            }
            
            if(this.user && this.edit){
                this.error = false
                //try to relogin
                response = await this.$store.dispatch('login', { cpf:this.clientInfo.cpf, password:this.clientInfo.password } ) 
                 if(response.error){
                    this.error = response.data.error.message;
                    return false;
                 }

                //if ok, save data
                response = await this.$store.dispatch('updateUser', this.clientInfo )
                 if(response.error){
                    this.error = response.data.error.message;
                    return false;
                 }
                 return true;
            }
            
            if(this.userWithDataExist){
                response = await this.$store.dispatch('login', { cpf:this.clientInfo.cpf, password:this.clientInfo.password } ) 
            
            }else{
                var formValid = await this.validateForms();
                if(formValid){
                    if(this.userWithDataExist){
                        
                    }else{
                        response = await this.$store.dispatch('register', this.clientInfo )
                    }
                }else{
                    return false
                }
            }

            if(response.error){
                    this.error = response.data.error.message;
                    return false;
            }else{
                return true;
            }

        }
    }

}
</script>

<style>

</style>
